<template>
  <div class="footer">
    <slot>
      © Copyright {{ year }} McCluskey Chevrolet. All rights reserved.
      <div style="float: right">
        {{ git }}
      </div>
    </slot>
  </div>
</template>

<style lang="less">
.footer {
  text-align: center;
  display: block;
  width: 100%;
  border: none;
  margin: 0;
  padding: 0 10px;
  background-color: rgb(101, 101, 101);
  color: white;
}
</style>

<script>
export default {
  data () {
    return {
      year: (new Date()).getFullYear(),
      git: '0.0.0-4c237b6'
    }
  }
}
</script>